import Vue from 'vue'
import * as jsonpatch from 'fast-json-patch/index.mjs'

const luAgencyDivision = {
  state: {
    luAgencyDivisions: [],
    selectedLuAgencyDivision: {},
    selectedLuAgencyDivisionOriginal: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    luAgencyDivisions(state) {
      return state.luAgencyDivisions
    },
    selectedLuAgencyDivision(state) {
      return state.selectedLuAgencyDivision
    },
    selectedLuAgencyDivisionOriginal(state) {
      return state.selectedLuAgencyDivisionOriginal
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    luAgencyDivisions(state, payload) {
      state.luAgencyDivisions = payload
    },
    selectedLuAgencyDivision(state, payload) {
      state.selectedLuAgencyDivision = JSON.parse(JSON.stringify(payload))
    },
    selectedLuAgencyDivisionOriginal(state, payload) {
      state.selectedLuAgencyDivisionOriginal = JSON.parse(
        JSON.stringify(payload)
      )
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedLuAgencyDivision(context, payload) {
      context.commit('selectedLuAgencyDivision', payload)
    },
    async loadLuAgencyDivisions(context, payload) {
      const url = 'LuAgencyDivision'
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('luAgencyDivisions', res.data)
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async refreshSelectedLuAgencyDivision(context, payload) {
      if (
        context.state.selectedLuAgencyDivision &&
        context.state.selectedLuAgencyDivision.Id > 0
      ) {
        return await context.dispatch(
          'loadSelectedLuAgencyDivision',
          context.state.selectedLuAgencyDivision.Id
        )
      }
    },
    async loadSelectedLuAgencyDivision(context, payload) {
      if (
        context.state.selectedLuAgencyDivision &&
        context.state.selectedLuAgencyDivision.Id != payload
      ) {
        context.commit('selectedLuAgencyDivision', {})
      }
      const url = 'LuAgencyDivision/' + payload
      context.commit('increaseSearchCount')
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('selectedLuAgencyDivision', res.data)
        context.commit('selectedLuAgencyDivisionOriginal', res.data)
        context.commit('decreaseSearchCount')
        return res
      } catch (err) {
        console.error(err)
        context.commit('decreaseSearchCount')
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async clearLookupCacheAndReloadLuAgencyDivisions(context, payload) {
      await caches.delete('apilookup-cache')
      return await context.dispatch('loadLuAgencyDivisions')
    },
    async createLuAgencyDivision(context, payload) {
      const url = `LuAgencyDivision`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.post(url, payload)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'agency division created' },
          { root: true }
        )
        //if you will always need to reload the list after an item is created
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadLuAgencyDivisions')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async patchLuAgencyDivision(context, payload) {
      var item = context.state.selectedLuAgencyDivision
      if (
        payload.Id &&
        payload.Id == context.state.selectedLuAgencyDivisionOriginal.Id
      ) {
        item = payload
      }
      var patchPayload = {}
      if (!payload.patchDoc || !payload.Id) {
        let original = context.state.selectedLuAgencyDivisionOriginal
        let current = item
        patchPayload.Id = item.Id
        var diff = jsonpatch.compare(original, current)
        patchPayload.patchDoc = diff
      } else {
        patchPayload = payload
      }
      if (patchPayload.patchDoc.length > 0) {
        const url = `LuAgencyDivision/${patchPayload.Id}`
        context.commit('saving', true)
        try {
          let res = await Vue.prototype.$axios.patch(url, patchPayload.patchDoc)
          context.dispatch(
            'messages/toastMessage',
            { color: 'success', message: 'agency division updated' },
            { root: true }
          )
          //if you will always need to reload the list after an update
          //you can uncomment out the following dispatch line.
          //Alternatively you can reload whatever object you need
          //when the promise resolves in the component that called it.
          //context.dispatch('loadLuAgencyDivisions')
          context.commit('saving', false)
          return res
        } catch (err) {
          console.error(err)
          context.commit('saving', false)
          context.dispatch('errors/handleError', err, { root: true })
          throw err
        }
      } else {
        return 'no changes'
      }
    },
    async updateLuAgencyDivision(context, payload) {
      const url = `LuAgencyDivision/${payload.Id}`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.put(url, payload)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'agency division updated' },
          { root: true }
        )
        //if you will always need to reload the list after an update
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadLuAgencyDivisions')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async saveLuAgencyDivision(context, payload) {
      if (payload.Id > 0) {
        return context.dispatch('updateLuAgencyDivision', payload)
      } else {
        return context.dispatch('createLuAgencyDivision', payload)
      }
    },
    async deleteLuAgencyDivision(context, payload) {
      const url = `LuAgencyDivision/${payload.Id}`
      try {
        let res = await Vue.prototype.$axios.delete(url)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'agency division deleted' },
          { root: true }
        )
        //if you will always need to reload the list after a delete
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadLuAgencyDivisions')
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
  },
}

export default luAgencyDivision
